
const actions = {
  //delete chat message/s functionality
  async deleteMessageHandler({getters, dispatch}, {messageId}) {
    dispatch('popups/chat/confirmDeleteMessage', async() => {
      let res = await dispatch('api/chat/deleteMessage', messageId)

      if(res.success) {
        dispatch('popups/show/success/deleting', 'Message')
        dispatch('removeMessageFromChatFeed', {
          data: {
            data: {messageId},
            destinationId: getters.getChatLocation.id
          }
        })
        dispatch('analytics/deleteChatMessage', [messageId, getters['current_user/isAreaAdmin']])
      } else {
        //show error
        dispatch('popups/show/error/deleting', 'This message')
      }
    })
  },

  // admin delete all messages in a conversation
  async deleteAllChatMessagesHandler({getters,dispatch}) {
    dispatch('popups/chat/confirmDeleteAllMessages', async() => {
      let res = await dispatch('api/chat/adminClearAllMessages', getters.getChatLocation.id)

      if(res.success) {
        dispatch('popups/show/success/deleting', 'All messages')
        dispatch('clearChatMessages')
        dispatch('analytics/deleteAllChatMessages')
      } else {
        //show error
        dispatch('popups/show/error/deleting', 'This conversation')
      }
    })
  }
};

export default {
  actions
};
